import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Flex, Box } from 'reflexbox';
import InlineAlert from '@ikea-ux/inline-alert';

import Text from 'components/Text';
import Button from 'components/Button';
import MoveToList from './components/MoveToList';
import FormSelect from 'components/Select';

// Modules
import { getQuantityOptions } from 'helpers/Product';
import { getText } from 'helpers/i18n';

import imgTrashCan from 'images/remove-thin-24.svg';
import imgShoppingBag from 'images/buy-online-add-thin-24-white.svg';

import './productControls.styles.scss';
import '@ikea-ux/svg-icon/dist/style.css';
import '@ikea-ux/inline-alert/dist/style.css';

export default class ProductControls extends Component {
    onShowRemoveConfirmation() {
        const { toggleRemoveConfirmation, article } = this.props;
        toggleRemoveConfirmation(article, true);
    }

    onHideRemoveConfirmation() {
        const { toggleRemoveConfirmation, article } = this.props;
        toggleRemoveConfirmation(article, false);
    }

    onChangeQuantity(name, value) {
        const { changeQuantity, selectedList, productData, quantity, resetStockCheck } = this.props;
        const quantityDelta = value - quantity;
        changeQuantity(productData, selectedList, value, quantityDelta);
        resetStockCheck();
    }

    render() {
        const { article, className, productData, quantity, showRemoveConfirmation, selectedListName, shoppingListView, partialQuantity, removingItems, isPurchasableFoodItem } = this.props;

        if (showRemoveConfirmation) {
            return (
                <Box wrap flex className="product__remove-confirmation-container" role="alertdialog">
                    <Box w={1} pb={1} className="product__remove-confirmation-text" id={'deleteProductConfirmation' + article}>
                        <p dangerouslySetInnerHTML={{
                            __html: getText('product_remove_confirmation_onlineshoppingcart', {
                                list: selectedListName,
                            }),
                        }}/>
                    </Box>

                    <Box className="product__remove-confirmation-no" w={1 / 2}>
                        <Button
                            theme="secondary-blue"
                            ariaLabel={getText('product_remove_no_aria')}
                            text="product_remove_no"
                            onClick={this.onHideRemoveConfirmation.bind(this)}
                            autoFocus
                        />
                    </Box>
                    <Box className="product__remove-confirmation-yes" w={1 / 2}>
                        <Button
                            theme="secondary-blue"
                            ariaLabel={getText('product_remove_yes_aria')}
                            text="product_remove_yes"
                            disabled={removingItems}
                            onClick={this.removeProduct.bind(this)}
                        />
                    </Box>
                </Box>
            );
        }

        return (
            <>
                <div className="product-controls__movetolist">
                    <MoveToList
                        article={article}
                        text={null}
                    />
                </div>
                {!productData.onlineSellable && shoppingListView === 'buyonline' &&
                    <Box w={1} mb={1}>
                        {isPurchasableFoodItem
                            ? <InlineAlert
                                size="s"
                                type="info"
                                message={<Text textKey="product_smf_only_pup"/>}
                            />
                            : <InlineAlert
                                size="s"
                                type="warning"
                                message={<Text textKey="product_cannot_add_to_bag"/>}
                            />
                        }
                    </Box>
                }
                <Flex auto className={`product-controls ${className}`}>
                    <Box className="product-controls__remove" w={1 / 8}>
                        <Button
                            theme="secondary"
                            ariaLabel={getText('product_remove_item')}
                            text="product_remove_item"
                            icon={imgTrashCan}
                            iconOnly
                            onClick={this.onShowRemoveConfirmation.bind(this)}
                        />
                    </Box>
                    <Box className="product-controls__quantity" w={2 / 8}>
                        <FormSelect
                            options={getQuantityOptions(partialQuantity)}
                            name={'qty_' + productData.articleNumber}
                            id={'js_qty_' + productData.articleNumber}
                            onChange={this.onChangeQuantity.bind(this)}
                            defaultValue={partialQuantity && partialQuantity < quantity ? partialQuantity : quantity}
                            ariaLabel={getText('price_package_quantity_aria_label')}
                        />
                    </Box>
                    <Box className="product-controls__move" w={5 / 8}>
                        {window.Checkout.settings.allow_add_to_bag && productData.onlineSellable && shoppingListView === 'buyonline' &&
                            <Button
                                theme="primary"
                                ariaLabel={getText('product_add_to_bag')}
                                text="product_add_to_bag"
                                icon={imgShoppingBag}
                                onClick={this.addToBag.bind(this)}
                            />
                        }
                    </Box>
                </Flex>
            </>
        );
    }

    removeProduct() {
        const { removeProduct, productData, selectedList, removingItems, resetStockCheck } = this.props;

        if (removingItems) return;

        removeProduct(productData, selectedList);
        resetStockCheck();
    }

    addToBag() {
        const { addToBag, article, productData, quantity } = this.props;

        addToBag(article, productData.productName, productData.articleType, quantity);
    }
}

ProductControls.propTypes = {
    productData: PropTypes.object.isRequired,
    quantity: PropTypes.number,
    article: PropTypes.string.isRequired,
    className: PropTypes.string,
    removeProduct: PropTypes.func.isRequired,
    removingItems: PropTypes.bool,
    toggleRemoveConfirmation: PropTypes.func.isRequired,
    addToBag: PropTypes.func.isRequired,
    showRemoveConfirmation: PropTypes.bool,
    changeQuantity: PropTypes.func.isRequired,
    selectedList: PropTypes.any,
    selectedListName: PropTypes.string,
    shoppingListView: PropTypes.string,
    partialQuantity: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.number,
    ]),
    resetStockCheck: PropTypes.func,
    isPurchasableFoodItem: PropTypes.bool.isRequired,
};
